import axios from "axios";

export default class Guideline {
	constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getGuidelines() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/bin/generals/Transport-Guidelines`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async postGuidelines(body, author) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/bin/generals`,
        data: {
          name: "Transport-Guidelines",
          title: "Reglamento",
          author: author,
          body: body
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
}
